export default __webpack_public_path__ + "static/media/file-upload.fdb6fcfa.svg";